import { ComponentType } from "@grafikr/components";
import fastdom from "fastdom";
import Cart from "utils/cart";
import Algolia from "utils/algolia";
import LineItem from "@grafikr/shopify-typescript/type/LineItem";
import { v4 as uuidv4 } from 'uuid';
import klaviyoAtc from 'utils/klaviyo-atc';

const Component: ComponentType = (node: HTMLFormElement, { emitter }) => {
  const form: HTMLFormElement = node.querySelector("form[action=\"/cart/add\"]");
  const button = form.querySelector('[data-atc]');
  const queryID = new URLSearchParams(window.location.search)?.get("queryID") ?? null;
  const error = form.querySelector<HTMLElement>("[data-error]");
  const client = new Algolia();

  const handleSubmit = async (event: SubmitEvent) => {
    event.preventDefault();

    const selectId: HTMLSelectElement = form.querySelector("select[name=\"id\"]");
    const comparePrice = selectId.querySelector<HTMLSelectElement>(`option[value="${selectId.value}"]`)?.dataset?.compare || "0";
    const tukTag = theme.tukTag.sort((a, b) => a.title.localeCompare(b.title)).find(item => {
      return item.price === 0 || item.title.includes('Gratis')
    }) || theme.tukTag.sort((a, b) => a.title.localeCompare(b.title))[0];
    const uid = uuidv4();

    const productsToAdd: { items: { id: number; quantity: number; properties?: any }[] } = {
      items: []
    };

    productsToAdd.items.push({
      id: +selectId.value,
      quantity: 1,
      properties: {
        _bundleId: uid,
        _comparePrice: comparePrice
      }
    });

    productsToAdd.items.push({
      id: tukTag.id,
      quantity: 1,
      properties: {
        _bundleId: uid,
        _comparePrice: tukTag.compareAtPrice
      }
    });

    Cart.addMultiple(productsToAdd, {
      success: (body: { items: LineItem[] }) => {
        fastdom.mutate(() => {
          error.hidden = true;
        });

        client.track("convertedObjectIDs", {
          index: "products",
          eventName: "Product Added",
          objectIds: body.items.map((i) => i.product_id.toString()),
          queryID
        });

        emitter.emit("cart:open");
        emitter.emit("cart:added");

        const formData = new FormData(form)
        klaviyoAtc(formData.get('handle').toString());
      },
      error: (body) => {
        fastdom.mutate(() => {
          error.hidden = false;
          error.textContent = body.message;
        });

        emitter.emit("cart:error", body);
      }
    });
  };

  button.addEventListener("click", handleSubmit);
};

export default Component;
